// extracted by mini-css-extract-plugin
module.exports = {"win-card-box":"gT","winCardBox":"gT","win-card-btn-detail":"gU","winCardBtnDetail":"gU","win-card-dec":"gV","winCardDec":"gV","win-card-name":"gW","winCardName":"gW"};